"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var StyledBackdrop = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: ", ";\n  padding: 0;\n  border: none;\n  overflow: auto;\n  background-color: ", ";\n  z-index: 998;\n  transition: background-color 0.5s ease;\n  outline: none;\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: ", ";\n  padding: 0;\n  border: none;\n  overflow: auto;\n  background-color: ", ";\n  z-index: 998;\n  transition: background-color 0.5s ease;\n  outline: none;\n"])), function (_a) {
  var open = _a.open;
  return open ? '100%' : '0';
}, function (_a) {
  var open = _a.open;
  return open ? 'rgba(0, 0, 0, 0.5)' : 'transparent';
});

exports.Backdrop = function (_a) {
  var children = _a.children,
      open = _a.open,
      onClose = _a.onClose;

  var handleClose = function handleClose(e) {
    e.preventDefault();
    onClose();
  };

  return react_1.default.createElement(StyledBackdrop, {
    open: open,
    onClick: handleClose
  }, children);
};

var templateObject_1;